import { VehicleMROResponse } from "../../app/features/vehicles/domain/mro-manual-model";
import { MroStatus } from "../../app/features/vehicles/infrastructure/enums/mro-status.enum";
import { MROType } from "../../app/features/vehicles/infrastructure/enums/mro-type.enum";
import { ReadingType } from "../../app/features/vehicles/infrastructure/enums/reading-type.enum";

export const VehicleMROResponseMock: VehicleMROResponse = {
    id: '1',
    vehicleId: '1',
    mroType: MROType.ODOMETER_CAPTURE,
    status: {
        name: MroStatus.DEACTIVATED,
        reason: 'Pending',
        dateTime: '2025-06-10T18:02:04.000Z'
    },
    initialMilesReading: {
        reportingPeriodId: '1',
        readingType: ReadingType.INITIAL_READING,
        miles: 100,
        readingDate: '2025-06-10T18:02:04.000Z',
        readingPeriodStartDate: null,
        readingPeriodEndDate: null,
        incrementMiles: null
    },
    lastMilesReading: {
        reportingPeriodId: '1',
        readingType: ReadingType.REGULAR_READING,
        miles: 200,
        readingDate: '2025-06-10T18:02:04.000Z',
        readingPeriodStartDate: null,
        readingPeriodEndDate: null,
        incrementMiles: null
    },
    finalMilesReading: {
        reportingPeriodId: '1',
        readingType: ReadingType.DEACTIVATION_READING,
        miles: 300,
        readingDate: '2025-06-10T18:02:04.000Z',
        readingPeriodStartDate: null,
        readingPeriodEndDate: null,
        incrementMiles: null
    },
};
